module.exports = __webpack_public_path__ + "static/media/red-p.180dfe2b.svg";